var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_vm._v(" "+_vm._s(_vm.title)+": ")]),_c('v-col',{attrs:{"cols":"6"}},[_vm._v(" "+_vm._s(_vm.value .toString() .split(/(?=(?:\d{3})+(?:\.|$))/g) .join(","))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }